import { capitalize } from 'lodash';
const formatFrequency = (frequency) => (frequency === 'continuous' ? 'Non-Recurring' : capitalize(frequency));
const formatStatus = (cardRequest) => {
    var _a;
    if (cardRequest.status === 'declined') {
        return 'Denied';
    }
    return cardRequest.is_modified_on_issuing ? 'Issued with revisions' : capitalize((_a = cardRequest.status) === null || _a === void 0 ? void 0 : _a.replace(/_/g, ' '));
};
function getCardIssuingLimit(company, userProfiles) {
    if (!company.is_manager_card_issuing_enabled) {
        return;
    }
    // we only use this value if every userProfile is the same
    const userProfileCardIssuingLimit = userProfiles[0].manager_card_issuing_limit;
    const companyCardIssuingLimit = company.manager_card_issuing_limit;
    const areAllCardIssuingLimitsMatching = userProfiles.every((profile) => profile.manager_card_issuing_limit === userProfileCardIssuingLimit);
    if (!userProfileCardIssuingLimit || !areAllCardIssuingLimitsMatching) {
        return companyCardIssuingLimit;
    }
    return userProfileCardIssuingLimit < companyCardIssuingLimit ? userProfileCardIssuingLimit : companyCardIssuingLimit;
}
function getPhysicalCardIssuingEnabledForUserProfiles(company, userProfiles) {
    if (!company.is_manager_card_issuing_enabled || !company.can_managers_issue_physical_cards) {
        return false;
    }
    // we only use this value if every userProfile is the same
    const allowPhysicalCardIssuing = userProfiles[0].can_issue_physical_cards;
    const areAllUsersSupportingPhysicalCardIssuing = userProfiles.every((profile) => profile.can_issue_physical_cards === allowPhysicalCardIssuing);
    return allowPhysicalCardIssuing && areAllUsersSupportingPhysicalCardIssuing;
}
export { formatFrequency, formatStatus, getCardIssuingLimit, getPhysicalCardIssuingEnabledForUserProfiles };
